export default __webpack_public_path__ + "static/media/03_modules.ddb42972.png";